import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.quote-slider').length) {

	function clearExitClasses(swiper) {
		swiper.slides.forEach(function(slide) {
			slide.classList.remove('is-exiting-left', 'is-exiting-right');
		});
	}

	var quoteSlider = new Swiper(".quote-slider .swiper", {
		effect: "fade",
		fadeEffect: {
			crossFade: false
		},
		loop: true,
		speed: 700,
		autoplay: {
			delay: 6000,
		},
		on: {
			slideNextTransitionStart: function(swiper) {
				clearExitClasses(swiper);
				swiper.slides[swiper.previousIndex]?.classList.add('is-exiting-left');
			},
			slidePrevTransitionStart: function(swiper) {
				clearExitClasses(swiper);
				swiper.slides[swiper.previousIndex]?.classList.add('is-exiting-right');
			},
			transitionEnd: function(swiper) {
				clearExitClasses(swiper);
			},
		},

    });

	requestAnimationFrame(function() {
		$('.quote-slider').addClass('is-animated');
	});

	$('.quote-slider .next').on('click', function() {
		quoteSlider.slideNext(1500);
	});

	$('.quote-slider .prev').on('click', function() {
		quoteSlider.slidePrev(1500);
	});

}
